export default {"src":"/_next/static/media/share-theme-icon.23c08555.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};